import { ReactElement, useEffect, useMemo, useState } from 'react'
import { GetStaticPropsContext } from 'next'
import Image from 'next/image'
import { gsap } from 'gsap'
import ScrollTrigger from 'gsap/dist/ScrollTrigger'
import { useTranslations } from 'next-intl'
import Link from 'next/link'
import { useRouter } from 'next/router'
import { NextPageWithLayout } from '../../common/common-types'
import retriveMessages, { LocaleType } from '../../messages/message'
import FullPageLayout from '../../components/full-page-layout/full-page-layout'
import PdImage from '../../components/pd-image/pd-image'
import PdForm, { FieldItem } from '../../components/pd-atom-form/pd-atom-form'
import { FieldValues } from 'react-hook-form'
import { withSEO } from '../../common/with-seo'
import { submitForm } from '../../service/form.service'
import toast, { Toaster } from 'react-hot-toast'

gsap.registerPlugin(ScrollTrigger)

const JPPuduBot2: NextPageWithLayout = () => {
  const t = useTranslations()
  const router = useRouter()
  const [agree, setAgree] = useState(0)
  const [isMobile, setIsMobile] = useState(false)
  const [messageIndex, setMessageIndex] = useState(0)

  const Characteristic: {
    src: string
    title: string
    desc: string
  }[] = [
    {
      src: 'https://cdn.pudutech.com/official-website/ad/pudubot2/Characteristic-1.png',
      title: 'PUDU SLAMで導入の簡素化、適応性の向上',
      desc: 'マーカーのない展開により、天井を再装飾することなく展開時間を75％短縮し、高い天井環境でも信頼性の高い操作で快適に使用可能。',
    },
    {
      src: 'https://cdn.pudutech.com/official-website/ad/pudubot2/Characteristic-2.png',
      title: '業界をリードするシャーシシステム',
      desc: '新しくアップグレードされた垂直リンケージサスペンションシステムを備えた高度に統合されたシャーシで、障害物横断能力が大幅に向上する。さまざまな路面に適応し、移動安定性が30％向上する。',
    },
    {
      src: 'https://cdn.pudutech.com/official-website/ad/pudubot2/Characteristic-3.png',
      title: 'デュアルライダー、正確な感知',
      desc: 'デュアルライダーシステムは、PuduBot 2に360度のセンシング機能を提供し、環境機能を完全に表示できる。よりよく信頼性と安全性を向上させる。',
    },
  ]

  const Scenes: { name: string; img: string }[] = [
    { name: 'オフィスビル', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/01.png' },
    { name: '教育機関 ', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/02.png' },
    { name: '小売業界 ', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/03.png' },
    { name: '飲食店', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/04.png' },
    { name: '公共交通機関', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/05.png' },
    { name: '介護・医療機関', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/06.png' },
    { name: '工場', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/07.png' },
    { name: '住宅', img: 'https://cdn.pudutech.com/official-website/ad/jp-cc1-cases/08.png' },
  ]
  const Cleaning: string[] = [
    'https://cdn.pudutech.com/official-website/ad/pudubot2/Cleaning-1.png',
    'https://cdn.pudutech.com/official-website/ad/pudubot2/Cleaning-2.png',
    'https://cdn.pudutech.com/official-website/ad/pudubot2/Cleaning-3.png',
  ]

  const Delivery: {
    src: string
    desc: string
  }[] = [
    {
      src: 'https://cdn.pudutech.com/official-website/ad/pudubot2/Delivery-1.png',
      desc: '配送モード',
    },
    {
      src: 'https://cdn.pudutech.com/official-website/ad/pudubot2/Delivery-2.png',
      desc: '誕生日モード',
    },
    {
      src: 'https://cdn.pudutech.com/official-website/ad/pudubot2/Delivery-3.png',
      desc: 'クルーシングモード',
    },
    {
      src: 'https://cdn.pudutech.com/official-website/ad/pudubot2/Delivery-4.png',
      desc: '下げ膳モード',
    },
  ]

  const Specification: [string, string][][] = [
    [
      ['本体寸法', '580mm*535mm*1290mm'],
      ['本体重量', '39kg'],
    ],
    [
      ['トレーサイズ', '520mm*432mm'],
      ['積載量', '13kg/トレー、最大40kg'],
    ],
    [
      ['バッテリー寿命', '10~24h '],
      ['充電時間', '3h'],
    ],
    [
      ['通過幅', '80cm'],
      ['走行速度', '0.5m/s~1.2m/s'],
    ],
    [
      ['最大通過可能段差の高さ', '10mm'],
      ['傾斜角度', '≤5°'],
    ],
    [
      ['測位方法 ', 'PUDU VSLAM＋ & レーザー SLAM '],
      ['充電方法', 'ワイヤー＆自動充電'],
    ],
  ]

  const OverviewContentList = {
    title: '概要',
    messages: [
      ['キャペーン名', 'PuduBot2　無料お試しキャンペーン'],
      ['施行期間', '2023年6月1日ー2023年12月31日'],
      [
        '内容',
        'ご希望の施設・店舗に無料で「PuduBot2」最大１台を1~7日間導入いただけます。（施設・店舗によって異なります）',
      ],
      [
        '対象のお客様',
        '施設・店舗（飲食店、ホテル、介護施設、レジャー施設、小売店、スーパー、病院、量販店など）のオーナー様(※店舗の環境によっては制限あり)',
      ],
      [
        '適用条件',
        '• 1店舗につき最大1台まで（屋内で利用すること）<br/>• 申込期間中にお申込みフォームよりお申し込み手続きを行っていただく必要があります。<br/>• 詳細は相談可能です。',
      ],
    ],
  }

  const AttentionMessage = {
    title: '注意事項',
    messages: [
      [
        '',
        [
          '• お申し込みは、日本国内の法人に限ります。',
          '• お申し込み状況によりトライアル期間が遅れる可能性がありますが、キャンペーン期間中にお申込みいただいた方は特典の対象となります。',
          '• お申し込みは、1店舗1回限りとさせていただきます。重複してお申し込みされた場合は、無効とさせていただきます。',
          '• 当社からの連絡後、5営業日以内にご返答いただけない、もしくはお申込みフォームにてご記入いただいたご連絡先・メールアドレスに誤りがあり、ご連絡がつかない場合、本キャンペーンの特典実施を見送る場合がございます。',
          '• ヒアリング後に実施条件が折り合わない場合、本キャンペーンの特典実施を見送る場合があります。',
          '• お申込内容に虚偽がある場合、法人名等を偽ってお申込みされた場合、当社の判断でキャンペーンの対象から除外いたします。',
          '• 設置費用、搬送費などが発生する場合もあります。',
          '• ロボットの利用中の動画や画像をご提供いただければ幸いです。（お試しキャンペーンの優先順位となります）',
          '※その画像や動画をネット上で公開する事に同意していただく事が条件となります。',
          '• お客様の故意または過失による機体の毀損が確認された場合は、修理費用を請求させていただく場合があります。',
          '• 公序良俗に反する行為や、不正応募、明らかな商業行為などが認められる場合には、当社の判断で本キャンペーンの対象から除外いたします。',
          '• 本キャンペーンの解釈権はPudu Roboticsが所有します。内容・期間は予告なく変更する場合がありますので、あらかじめご了承ください。',
          '• 本キャンペーンに関する全てのお問い合わせは、global_sales@pudutech.comまでご連絡ください。',
        ].join('<br/>'),
      ],
    ],
  }

  const manualMessage = useMemo(() => {
    const validMessages = [OverviewContentList, AttentionMessage]
    return validMessages[messageIndex]
  }, [messageIndex])

  const FormFields: FieldItem[] = [
    {
      type: 'INPUT',
      label: '会社名',
      fieldName: 'companyName',
      placeholder: 'ご記入願います',
      rule: { required: true },
      fieldClassName: '!bg-white',
    },
    {
      type: 'INPUT',
      label: '氏名',
      fieldName: 'name',
      placeholder: 'ご記入願います',
      fieldClassName: '!bg-white',
      rule: { required: true },
    },
    {
      type: 'INPUT',
      label: 'メールアドレス',
      fieldName: 'email',
      placeholder: 'ご記入願います',
      rule: { required: true },
      fieldClassName: '!bg-white',
    },
    {
      type: 'INPUT',
      label: '電話番号',
      fieldName: 'phoneNumber',
      placeholder: 'ご記入願います',
      rule: { required: true },
      fieldClassName: '!bg-white',
    },
    {
      type: 'INPUT',
      label: '都道府県',
      fieldName: 'prefectures',
      placeholder: 'ご記入願います',
      rule: { required: true },
      fieldClassName: '!bg-white',
    },
    {
      type: 'INPUT',
      label: '店舗住所',
      fieldName: 'shopAddress',
      placeholder: 'ご記入願います',
      rule: { required: true },
      fieldClassName: '!bg-white',
    },
    {
      type: 'INPUT',
      label: '業種',
      fieldName: 'industry',
      placeholder: 'ご記入願います',
      fieldClassName: '!bg-white',
      rule: { required: true },
    },
    {
      type: 'INPUT',
      label: '役職',
      fieldName: 'officialPosition',
      placeholder: 'ご記入願います',
      rule: { required: true },
      fieldClassName: '!bg-white',
    },
    {
      type: 'INPUT',
      label: '店舗数・施設数',
      fieldName: 'storesNumber',
      placeholder: 'ご記入願います',
      rule: { required: true },
      fieldClassName: '!bg-white',
    },
    {
      type: 'INPUT',
      label: '導入開始希望日',
      fieldName: 'installationDate',
      placeholder: 'ご記入願います',
      rule: { required: true },
      fieldClassName: '!bg-white',
    },
    {
      type: 'TEXT',
      label: 'メーセージ',
      fieldName: 'message',
      placeholder: 'ご記入願います',
      rule: { required: false },
      fieldClassName: '!bg-white',
    },
  ]

  const HoverScaleImage: React.FC<{
    className: string
    src: string
    alt?: string
    scale?: boolean
    object?: 'cover' | 'contain' | 'fill'
  }> = ({ className, src, alt, scale = true, object }) => (
    <div className={[className, 'laptop:rounded-3xl rounded-xl overflow-hidden'].join(' ')}>
      <div
        className={[
          scale ? 'transition duration-1500 hover:ease-in-out hover:scale-120' : '',
          'w-full h-full bg-white',
        ].join(' ')}
      >
        <PdImage src={src} width="100%" height="100%" alt={alt || ''} object={object || 'cover'} enableMask={false} />
      </div>
    </div>
  )
  function handleSubmit(values: FieldValues) {
    submitForm({
      company: values.companyName,
      name: values.name,
      email: values.email,
      mobile: values.phoneNumber,
      province: values.prefectures,
      address: values.shopAddress,
      careerBackground: values.industry,
      jobTitle: values.officialPosition,
      remark: `门店数：${values.storesNumber}; 希望使用时间:${values.installationDate}; 用户留言： ${values.message}`,
      countryCode: 'JP',
    })
      .then((res) => {
        if (res.code === 200 || res.code === 0) {
          router.push(
            {
              pathname: '/contact-us/success',
              query: {
                email: values.email,
                phone: values.mobile,
                name: values.name,
                formId: 'jppudubot2',
              },
            },
            '/contact-us/success'
          )
        } else {
          const error = res.message
          toast.error(error)
        }
      })
      .catch((res) => {
        const response = res.response.data
        const error = response.message
        toast.error(error)
      })
  }

  useEffect(() => {
    setIsMobile(window.innerWidth <= 1200)

    const ctx = gsap.context(() => {
      if (window.innerWidth > 1200) {
        gsap.set('.banner-text', { transform: `scale(${window.innerWidth / 1920})` })
        gsap.set('.section2nd-card-0', { y: 50, opacity: 0 })
        gsap.set('.section2nd-card-1', { y: 150, opacity: 0 })
        gsap.set('.section2nd-card-2', { y: 250, opacity: 0 })
        ScrollTrigger.create({
          scroller: '#main',
          trigger: '#ad-pudubot2-section2nd',
          start: 'top center',
          end: 'bottom top',
          scrub: true,
          onEnter: () => {
            gsap.fromTo('.section2nd-card-0', { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6 })
            gsap.fromTo('.section2nd-card-1', { y: 150, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 })
            gsap.fromTo('.section2nd-card-2', { y: 250, opacity: 0 }, { y: 0, opacity: 1, duration: 1 })
          },
          onEnterBack: () => {
            gsap.fromTo('.section2nd-card-0', { y: 50, opacity: 0 }, { y: 0, opacity: 1, duration: 0.6 })
            gsap.fromTo('.section2nd-card-1', { y: 150, opacity: 0 }, { y: 0, opacity: 1, duration: 0.8 })
            gsap.fromTo('.section2nd-card-2', { y: 250, opacity: 0 }, { y: 0, opacity: 1, duration: 1 })
          },
          onLeave: () => {
            gsap.fromTo('.section2nd-card-2', { y: 0, opacity: 1 }, { y: 250, opacity: 0, duration: 0.6 })
            gsap.fromTo('.section2nd-card-1', { y: 0, opacity: 1 }, { y: 150, opacity: 0, duration: 0.8 })
            gsap.fromTo('.section2nd-card-0', { y: 0, opacity: 1 }, { y: 50, opacity: 0, duration: 1 })
          },
          onLeaveBack: () => {
            gsap.fromTo('.section2nd-card-2', { y: 0, opacity: 1 }, { y: 250, opacity: 0, duration: 0.6 })
            gsap.fromTo('.section2nd-card-1', { y: 0, opacity: 1 }, { y: 150, opacity: 0, duration: 0.8 })
            gsap.fromTo('.section2nd-card-0', { y: 0, opacity: 1 }, { y: 50, opacity: 0, duration: 1 })
          },
        })
        gsap
          .timeline({
            scrollTrigger: {
              scroller: '#main',
              trigger: '#ad-pudubot2-section5th',
              pin: true,
              start: 'top top',
              end: '+=100%',
              scrub: true,
            },
          })
          .to('#ad-pudubot2-section5th-A', {
            translateX: '-1200px',
          })

        ScrollTrigger.create({
          scroller: '#main',
          trigger: '#ad-pudubot2-section5th',
          // pin: '#ad-pudubot2-section6th',
          start: 'top top',
          end: '+=100%',
          pinSpacing: false,
        })
      }
    })

    return () => ctx.revert()
  }, [])

  return (
    <div className="w-full relative bg-[#E8E8E8]">
      {/* banner */}
      <section className={['w-full h-fit bg-pdblue', 'laptop:pt-10 laptop:pb-30'].join(' ')}>
        {/* banner-header */}
        <div className={['w-fit flex p-3', 'laptop:mx-auto laptop:p-0 laptop:mb-20 laptop:items-center'].join(' ')}>
          <div className={['w-85px h-25px', 'laptop:w-114px laptop:h-34px'].join(' ')}>
            <PdImage src="/logo-white.svg" width="100%" height="100%" alt="logo" object="contain" enableMask={false} />
          </div>
          <div className={['border-r border-white h-25px mx-3', 'laptop:h-34px laptop:mx-6'].join(' ')}></div>
          <span className={['laptop:text-20', 'text-14 text-white font-medium'].join(' ')}>
            {'世界をリードするロボット会社'}
          </span>
        </div>
        {/* banner-body */}
        <div className={['w-full relative z-0 flex', 'laptop:mx-auto'].join(' ')}>
          <div
            style={isMobile ? {} : { marginLeft: 'calc(120/1920*100vw)', marginTop: 'calc(109/1920*100vw)' }}
            className={['banner-text', 'absolute origin-top-left z-10 flex flex-col mt-10 ml-29px'].join(' ')}
          >
            <div className={['w-212px h-7', 'laptop:w-136 laptop:h-72px'].join(' ')}>
              <PdImage
                src="https://cdn.pudutech.com/official-website/ad/pudubot2/robot-name.svg"
                width="100%"
                height="100%"
                alt="pudubot2"
                object="cover"
                enableMask={false}
              />
            </div>
            <div className={['flex flex-col gap-2px mt-2', 'laptop:gap-4 laptop:mt-6'].join(' ')}>
              <p className={['text-28.8 text-white font-semibold', 'laptop:text-72'].join(' ')}>
                {'無料お試しキャンペーン'}
              </p>
              <div className={['laptop:h-2', 'bg-white h-1'].join(' ')}></div>
            </div>
            <div className={['laptop:mt-4 mt-7px'].join(' ')}>
              <span
                className={['text-white font-semibold !leading-none mr-2 text-12', 'laptop:text-24 laptop:mr-4'].join(
                  ' '
                )}
              >
                {'2023'}
              </span>
              <span className={['text-white font-semibold !leading-none text-20', 'laptop:text-48'].join(' ')}>
                {'6.1-12.31'}
              </span>
            </div>
            <div
              className={[
                'bg-white mt-3 px-3 py-6px w-fit',
                'laptop:mt-10 laptop:px-26px laptop:py-4 laptop:w-136',
              ].join(' ')}
            >
              {['クラシックより上位交換', 'ユニバーサルデリバリーロボット'].map((item) => (
                <p key={item} className={['laptop:text-32', 'text-black/90 font-semibold'].join(' ')}>
                  {item}
                </p>
              ))}
            </div>
          </div>
          <div
            style={
              isMobile
                ? {}
                : {
                    width: 'calc(1560/1920*100vw)',
                    height: 'calc(878/1920*100vw)',
                  }
            }
            className={['ml-auto overflow-hidden'].join(' ')}
          >
            <div
              className={[
                'w-327px h-105 pt-180px box-content',
                'laptop:pt-0 laptop:w-full laptop:h-full transition duration-1500 hover:ease-in-out hover:scale-120',
              ].join(' ')}
            >
              <PdImage
                src="https://cdn.pudutech.com/official-website/ad/pudubot2/ads-banner.png"
                width="100%"
                height="100%"
                alt="banner"
                object="cover"
                enableMask={false}
              />
            </div>
          </div>
        </div>
        {/* banner-footer */}
        <div className={['w-276px mx-auto mt-6 pb-15', 'laptop:w-300 laptop:mt-30 laptop:pb-0'].join(' ')}>
          <p className={['laptop:w-900px laptop:text-24', 'text-white font-semibold'].join(' ')}>
            {
              'Pudubot 2は、すべてのシナリオでインテリジェントな配送を実現し、サービスロボットのアプリケーションを促進し、より高いパフォーマンス、より良い拡張性、適応性と信頼性で全体的なロボット開発を加速する'
            }
          </p>
        </div>
      </section>
      <section
        id="ad-pudubot2-section2nd"
        className={['w-full h-fit bg-[#e8e8e8] py-15 px-6', 'laptop:py-30 laptop:px-0'].join(' ')}
      >
        <div
          className={['grid grid-cols-1 gap-15', 'laptop:w-300 laptop:mx-auto laptop:grid-cols-3 laptop:gap-6'].join(
            ' '
          )}
        >
          {Characteristic.map((item, index) => (
            <div
              key={index}
              className={[`section2nd-card-${index}`, 'flex flex-col items-center', 'laptop:items-start'].join(' ')}
            >
              <div
                className={[
                  'w-327px h-210px rounded-xl overflow-hidden',
                  'laptop:w-full laptop:h-105 laptop:rounded-3xl',
                ].join(' ')}
              >
                <div className={['w-full h-full transition duration-1500 hover:ease-in-out hover:scale-120'].join(' ')}>
                  <PdImage
                    src={item.src}
                    width="100%"
                    height="100%"
                    alt={item.title}
                    object="cover"
                    enableMask={false}
                  />
                </div>
              </div>
              <h3
                className={[
                  'text-black/90 font-semibold mt-6 text-18',
                  'laptop:text-20 laptop:mt-6 laptop:h-56px laptop:w-336px',
                ].join(' ')}
              >
                {item.title}
              </h3>
              <p className={['text-black/90 font-normal mt-3 text-14', 'laptop:text-18 laptop:mt-4'].join(' ')}>
                {item.desc}
              </p>
            </div>
          ))}
        </div>
      </section>
      <section className={['w-full h-fit bg-pdblue pt-15 px-6', 'laptop:pt-30 laptop:px-0'].join(' ')}>
        <div className={['laptop:w-300 laptop:mx-auto laptop:flex laptop:flex-col'].join(' ')}>
          <h2 className={['font-semibold text-white text-center text-24 mb-3', 'laptop:mb-6 laptop:text-48'].join(' ')}>
            {'豊富なアクセサリー'}
          </h2>
          <p
            className={['font-semibold text-white text-center text-14 mb-7', 'laptop:mb-16 laptop:text-base'].join(' ')}
          >
            {'調節可能なトレー及び様々なアクセサリーによって、店舗内の状況に合わせて、全ての使用シーンに対応できる。'}
          </p>
          <div className={['grid grid-cols-1 gap-7', 'laptop:w-full laptop:grid-cols-3 laptop:gap-6'].join(' ')}>
            {Cleaning.map((item, index) => (
              <HoverScaleImage
                key={index}
                className={'laptop:w-full laptop:h-384px w-327px h-48'}
                src={item}
                alt={''}
                scale={false}
                object={isMobile ? 'contain' : 'cover'}
              />
            ))}
          </div>
          <div
            className={[
              'bg-[#E8E8E8] rounded-xl relative top-13 flex flex-col px-4 py-6',
              'laptop:top-16 laptop:h-566px laptop:mt-20 laptop:rounded-3xl laptop:px-16 laptop:py-0 laptop:flex-row laptop:justify-between laptop:items-center',
            ].join(' ')}
          >
            <div className={['flex flex-col gap-3', 'laptop:w-150 laptop:gap-6'].join(' ')}>
              <h3 className={['text-24', 'text-black/90 font-semibold laptop:text-48'].join(' ')}>
                {'自動充電、常にスタンバイ'}
              </h3>
              <p className={['text-14', 'text-black/90 font-semibold laptop:text-base'].join(' ')}>
                {'手作業による介入なしで設定時間またはバッテリーレベルが設定した値より低い場合の自動再充電できる。'}
              </p>
            </div>
            <HoverScaleImage
              className={[
                'mt-8 w-295px h-110',
                'laptop:mt-0 laptop:w-370px laptop:h-566px laptop:relative laptop:-top-16',
              ].join(' ')}
              src={'https://cdn.pudutech.com/official-website/ad/pudubot2/Cleaning-4.png'}
              alt={''}
              scale={false}
            />
          </div>
        </div>
      </section>
      <section className={['bg-white pt-90px laptop:pt-16'].join(' ')}>
        <div className={['py-15 px-6', 'laptop:w-300 laptop:px-0 laptop:py-40 laptop:mx-auto'].join(' ')}>
          <h2
            className={['font-semibold text-black/90 text-24 text-center mb-8 laptop:text-48 laptop:mb-16'].join(' ')}
          >
            {'様々な配送モード、多様な配送シナリオを対応できる'}
          </h2>
          <div
            className={[
              'grid grid-cols-2 gap-y-10 gap-x-15 w-full px-6',
              'laptop:w-928px laptop:mx-auto laptop:grid-cols-4 laptop:gap-24 laptop:px-0',
            ].join(' ')}
          >
            {Delivery.map((item, index) => (
              <div
                key={index}
                className={['w-110px flex flex-col items-center gap-3', 'laptop:w-auto laptop:gap-6'].join(' ')}
              >
                <div className={['laptop:w-40 laptop:h-40 w-110px h-110px'].join(' ')}>
                  <PdImage
                    src={item.src}
                    width="100%"
                    height="100%"
                    alt={item.desc}
                    object="cover"
                    enableMask={false}
                  />
                </div>
                <p
                  className={[
                    'font-semibold text-black/90 text-center',
                    'laptop:text-20 laptop:whitespace-nowrap',
                  ].join(' ')}
                >
                  {item.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
      {isMobile ? (
        <section className={['bg-[#E8E8E8] px-6 py-15 flex flex-col gap-30px'].join(' ')}>
          <h2 className="text-24 font-semibold text-black/90 text-center">{'様々なシナリオに対応可能'}</h2>
          <div className={['flex flex-wrap gap-y-10 justify-between'].join(' ')}>
            {Scenes.map((scene) => (
              <div key={scene.name} className="text-center">
                <div className="w-157px h-157px rounded-xl overflow-hidden">
                  <PdImage
                    src={scene.img}
                    alt={scene.name}
                    enableMask={false}
                    object="cover"
                    width={'100%'}
                    height={'100%'}
                  />
                </div>
                <p className="mt-3 text-14 text-black/90">{scene.name}</p>
              </div>
            ))}
          </div>
        </section>
      ) : (
        <section id="ad-pudubot2-section5th" className="w-full bg-[#E8E8E8] overflow-hidden relative z-10">
          <div className="w-300 my-30 mx-auto flex flex-col space-y-64px">
            <h3 className="text-center m-0 text-48 text-black/90 font-semibold">{'様々なシナリオに対応可能'}</h3>
            <ul
              id="ad-pudubot2-section5th-A"
              className="pr-60 flex flex-row gap-x-10 transition-transform duration-500"
            >
              {Scenes.map((scene) => (
                <li key={scene.name} className="text-center shrink-0">
                  <div className="w-67 h-67 rounded-3xl overflow-hidden">
                    <PdImage
                      src={scene.img}
                      alt={scene.name}
                      enableMask={false}
                      object="cover"
                      width={'100%'}
                      height={'100%'}
                    />
                  </div>
                  <h5 className="mt-9 text-20 text-black/90 font-bold">{scene.name}</h5>
                </li>
              ))}
            </ul>
          </div>
        </section>
      )}
      <section id="ad-pudubot2-section6th" className="bg-white text-center py-15 laptop:pt-70px laptop:pb-136px">
        <h2 className="text-24 laptop:text-48 font-bold text-black/90">{'PuduBot２スペック紹介'}</h2>
        <div className="mt-3 laptop:mt-90px flex flex-col laptop:flex-row max-w-full w-300 mx-auto">
          <div className="flex-1 laptop:mr-108px">
            <Image
              alt="pudubot2 robot"
              src="https://cdn.pudutech.com/official-website/ad/pudubot2/pudubot2-robot.png"
              width={isMobile ? '250' : '500'}
              height={isMobile ? '325' : '650'}
            />
          </div>

          <div className="flex-1 px-6 laptop:flex laptop:flex-col laptop:justify-center laptop:px-0 space-y-3 laptop:space-y-0">
            {Specification.map((spec, index) => (
              <div
                key={index}
                className="flex flex-col laptop:flex-row w-full laptop:w-148 laptop:py-4 laptop:border-b border-black/20 text-left laptop:gap-x-6 gap-y-3"
              >
                <div className="flex-1 text-sm laptop:text-base font-normal border-b border-black/20 laptop:border-0 pb-3 laptop:pb-0">
                  <p className="text-black/40 mb-1 laptop:mb-2">{spec[0][0]}</p>
                  {spec[0][1].split('<br/>').map((text) => (
                    <p key={text} className="text-black/90 text-12 laptop:text-base">
                      {text}
                    </p>
                  ))}
                </div>

                <div className="flex-1 text-sm laptop:text-base font-normal border-b border-black/20 laptop:border-0 pb-3 laptop:pb-0">
                  <p className="text-black/40 mb-1 laptop:mb-2">{spec[1][0]}</p>
                  {spec[1][1].split('<br/>').map((text) => (
                    <p key={text} className=" text-12 laptop:text-base text-black/90">
                      {text}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="relative w-full h-fit box-border bg-[#e8e8e8] before:absolute before:top-0 before:block before:content-[''] before:w-full before:h-410px laptop:before:h-150 before:bg-pdblue">
        <div className="relative flex flex-col items-center laptop:justify-center laptop:items-start laptop:flex-row max-w-full w-full mx-auto">
          <div className="mt-15 laptop:mt-30 w-full laptop:w-390px text-center laptop:text-left">
            <h3 className="text-24 laptop:text-5xl text-white font-bold mb-4 laptop:mb-6">無料お試しはこちらから</h3>
            {!isMobile && (
              <Image
                alt="arrow icon"
                src="https://cdn.pudutech.com/official-website/ad/pudubot2/arrow.svg"
                width="78"
                height="28"
              />
            )}
          </div>

          <div className="w-326px laptop:w-fit flex flex-col gap-y-4 laptop:gap-y-6 p-4 laptop:p-8 rounded-xl laptop:rounded-3xl text-18 laptop:text-20 text-black/90 bg-white mt-8 laptop:mt-30 laptop:ml-16 border border-pdblue">
            <h5>{manualMessage.title}</h5>
            {manualMessage.messages.map((item, index) => (
              <div key={index} className="w-full laptop:w-680px text-sm laptop:text-base">
                {item[0] && <h5>{item[0]}</h5>}
                {item[1].split('<br/>').map((entry) => (
                  <p className="text-black/60 mt-1" key={entry}>
                    {entry}
                  </p>
                ))}
              </div>
            ))}

            <button
              className="self-end flex items-center mt-6 laptop:mt-12 bg-pdblue rounded-full w-fit px-3 laptop:px-6 py-1 laptop:py-2 text-12 laptop:text-base text-white gap-x-6px laptop:gap-x-2"
              onClick={() => setMessageIndex((messageIndex + 1) % 2)}
            >
              {messageIndex === 0 && (
                <>
                  <span>次のページ</span>
                  <Image
                    alt="pre"
                    src="https://cdn.pudutech.com/official-website/ad/pudubot2/button-arrow-pre.svg"
                    width={isMobile ? 16 : 22}
                    height={isMobile ? 8 : 10}
                  />
                </>
              )}
              {messageIndex === 1 && (
                <>
                  <Image
                    alt="next"
                    src="https://cdn.pudutech.com/official-website/ad/pudubot2/button-arrow.svg"
                    width={isMobile ? 16 : 22}
                    height={isMobile ? 8 : 10}
                  />
                  <span>前のページ</span>
                </>
              )}
            </button>
          </div>
        </div>
      </section>
      <section className="w-full bg-[#e8e8e8] py-15 laptop:py-30 px-6 laptop:px-0">
        <Toaster />
        <div id="form" className="max-w-full laptop:pt-30 w-300 mx-auto flex flex-col laptop:flex-row justify-between">
          <h3 className="w-full text-center  laptop:text-left laptop:w-390px text-22 laptop:text-5xl text-black/90 font-bold">
            資料請求・お申し込みはこちら
          </h3>
          <div className="max-w-full w-744px mt-8 laptop:mt-0">
            <div className="w-full border-b border-[#c2c2c2] mb-8 laptop:mb-12 pb-3 laptop:pb-6 ">
              <p className="text-18 laptop:text-24 text-black/90">PuduBot2 無料お試しキャンペーンお申し込み</p>
              <p className="text-sm laptop:text-base text-black/60 mt-3 laptop:mt-2">
                お客様の情報はセキュリティで保護されています。安心してご利用ください。
              </p>
            </div>
            <PdForm
              fields={FormFields}
              onSubmit={handleSubmit}
              bottomRender={(trigger, getValues, formState, formValidity) => {
                return (
                  <div className="mt-0">
                    <div className="flex flex-row gap-x-4">
                      <input name="agree" type="checkbox" value={agree} onChange={() => setAgree((prev) => 1 - prev)} />
                      <p className="text-12 laptop:text-sm text-black/60">
                        Pudu Roboticsは、お客様のプライバシーを保護し、尊重することをお約束します。
                        [送信]をクリックすると、Pudu Roboticsのプライバシーポリシーを読み、同意したことになります。 Pudu
                        Roboticsは、お客様の情報を使用して、更新や特別オファーについてお客様に連絡する場合があります。
                        いつでも退会できます。
                      </p>
                    </div>
                    <p className="text-12 laptop:text-sm text-pdblue mt-6 laptop:mt-12">
                      ※ご連絡先メールアドレス宛にお申し込み内容の控えをメールで送信します。メールアドレスの間違いが非常に多いので、再度ご確認お願い致します。
                    </p>

                    <input
                      className={[
                        'mt-8 laptop:mt-12 w-full laptop:w-fit laptop:px-76px py-13px laptop:py-18px rounded-full  text-white text-base laptop:text-xl cursor-pointer',
                        agree && formValidity ? 'bg-pdblue' : 'bg-d8',
                      ].join(' ')}
                      type="submit"
                      disabled={!(agree && formValidity)}
                      value="申し込み"
                    />
                  </div>
                )
              }}
            />
          </div>
        </div>
      </section>
      <div className="hidden laptop:block fixed right-16 bottom-16 z-50">
        <div className="flex justify-center items-center w-31 h-31 border-2 border-pdblue rounded-full bg-white">
          <img
            alt="pudubot2"
            src="https://cdn.pudutech.com/official-website/ad/pudubot2/pudubot2-fixed.png"
            className="-mt-10px"
          />
        </div>
        <Link href="#form">
          <button className="w-31 h-11 border-white border-2 rounded-full bg-pdblue font-bold text-white -translate-y-10">
            Contact Us
          </button>
        </Link>
      </div>
    </div>
  )
}

export const getStaticProps = withSEO(
  async ({ locale }: GetStaticPropsContext) => {
    const messages = retriveMessages(['ads'], locale as LocaleType)

    return {
      props: {
        messages,
      },
      revalidate: 60,
    }
  },
  () => '/ads/jp-pudubot2'
)

JPPuduBot2.getLayout = function (page: ReactElement, seo) {
  return (
    <FullPageLayout
      pageTitle={'PuduBot2'}
      pageDescription={seo.description}
      pageKeywrods={seo.keywords}
      ogtype={'website'}
      hideFooter={true}
    >
      {page}
    </FullPageLayout>
  )
}

export default JPPuduBot2
